/**
 * Mapping to dynamically import the date-fns Locale object for your locale.
 * You can extend this map if you need a locale that's currently not in there if it's supported by date-fns.
 * https://date-fns.org/v2.0.0-beta.2/docs/I18n#supported-languages
 */ const dateFnsLocaleMap = {
    en: ()=>import('date-fns/locale/en-GB')
    ,
    'en-GB': ()=>import('date-fns/locale/en-GB')
    ,
    'en-US': ()=>import('date-fns/locale/en-US')
    ,
    it: ()=>import('date-fns/locale/it')
    ,
    nl: ()=>import('date-fns/locale/nl')
    ,
    pt: ()=>import('date-fns/locale/pt')
    ,
    sv: ()=>import('date-fns/locale/sv')
    ,
    da: ()=>import('date-fns/locale/da')
    ,
    fr: ()=>import('date-fns/locale/fr')
    ,
    es: ()=>import('date-fns/locale/es')
    ,
    ca: ()=>import('date-fns/locale/ca')
};
/**
 * Gets the dynamic import for the passed locale.
 * Use this function to get your locale import, don't expose the map directly.
 *
 * @example
 * const dateFnsLocaleModule = getDateFnsLocaleModule('it-IT')
 * const { default: dateFnsLocale } = await dateFnsLocaleModule()
 */ function getDateFnsLocaleModule(locale) {
    if (dateFnsLocaleMap[locale]) {
        return dateFnsLocaleMap[locale]();
    }
    // If we can't find an obj for the more specific locale (en-GB),
    // Try to find a less specific one for the language code only (en).
    const language = locale.substr(0, 2);
    if (dateFnsLocaleMap[language]) {
        return dateFnsLocaleMap[language]();
    }
    return undefined;
}

export { dateFnsLocaleMap, getDateFnsLocaleModule };
//# sourceMappingURL=date-fns-locales.js.map
